import React, { ReactNode } from 'react';
import { LabeledCheckbox, LabeledInput } from '../fields';

import { SportType } from 'modules/tournaments/ui/components/form-parts/rules/types';
import UDFormDateRange from 'ud-form/components/datetime/range';
import { useLocation } from 'react-router-dom';

interface ApplicationCompanyBaseProps {
  sportType?: SportType;
  children?: ReactNode;
}

const ApplicationCompanyBase: React.FC<ApplicationCompanyBaseProps> = ({ sportType = 'general', children }) => {
  const location = useLocation();
  const highlight = location.state?.highlight || {};

  return (
    <div className="row g-2 mt-5">
      <div className="col-6">
        <UDFormDateRange
          startName="settings.applicationStartDate"
          endName="settings.applicationEndDate"
          startLabel="Начало приема заявок"
          endLabel="Окончание приема заявок"
          containerProps={{ className: 'mb-5' }}
          highlightStart={highlight?.applicationStartDate}
          highlightEnd={highlight?.applicationEndDate}
          startTooltip={{
            tooltip:
              'Дата, когда организатор начинает принимать заявки на участие в турнире. До этого момента команды не смогут зарегистрироваться.',
            tooltipProps: {
              position: 'input-right',
            },
          }}
          endTooltip={{
            tooltip:
              'Дата, после которой нельзя будет отправлять или редактировать заявки. Желательно установить с некоторым опережением перед началом турнира.',
            tooltipProps: {
              position: 'input-right',
            },
          }}
        />

        <LabeledInput
          name="settings.applicationMinPlayers"
          placeholder="0 чел"
          label="Минимальное количество игроков в заявке"
          tooltip={
            <div>
              Число игроков, необходимое для подтверждения заявки команды. Например, если указано "5", команда не сможет участвовать,
              пока не добавит 5 игроков.
              <br />
              <br />
              Значение "0" означает отсутствие ограничений.
            </div>
          }
          tooltipProps={{
            position: 'input-right',
          }}
        />

        <LabeledInput
          name="settings.applicationMaxPlayers"
          placeholder="0 чел"
          label="Максимальное количество игроков в заявке"
          tooltip={
            <div>
              Лимит заявленных игроков, которые могут быть в составе команды. Например, "10" – даже если у команды больше участников,
              заявить можно будет только 10 игроков.
              <br />
              <br />
              При значении "0" ограничение 28 игроков.
            </div>
          }
          tooltipProps={{
            position: 'input-right',
          }}
        />

        <LabeledInput
          name="settings.participationFee"
          placeholder="0 ₽"
          label="Взнос за участие"
          tooltip={
            <div>
              Сумма, которую должна оплатить команда для участия в турнире. Если указано "0 ₽", участие бесплатное. Данный параметр
              будет показываться в описании к турниру для участников.
              <br />
              <br />
              ⚠️Важно: Параметр несет исключительно информативный характер, платформа не принимает никакие платежи от участников
              турнира.
            </div>
          }
          tooltipProps={{
            position: 'input-right',
          }}
        />

        <LabeledCheckbox
          name="settings.applicationTransfersAllowed"
          label="Переходы возможны"
          tooltip={
            <div>
              Позволяет участникам менять команды после подачи запроса (например, если в турнире предусмотрена возможность "дозаявок"
              или замен).
              <br />
              <br />
              Если опция выключена – состав команды фиксируется после окончания заявочной кампании.
            </div>
          }
          tooltipProps={{
            position: 'input-right',
          }}
        />

        {children}
      </div>
    </div>
  );
};

export default ApplicationCompanyBase;
